import React, { Component } from 'react';
// Some component unit tests using this component are failing.
// eslint-disable-next-line no-restricted-imports
import { translate } from 'react-polyglot';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './TableCell.scss';
@translate()
class TableCell extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    role: PropTypes.string,
    columnName: PropTypes.string,
    t: PropTypes.func
  };

  static defaultProps = {
    role: 'cell',
    t: (t) => t
  };

  render() {
    const { children, className, label, onClick, role, columnName, t } =
      this.props;
    const classComponent = classNames(
      'table-cell',
      className,
      { clickable: onClick },
      { 'table-cell--data-header': columnName }
    );

    return (
      <div
        role={role}
        className={classComponent}
        onClick={onClick}
        data-header={columnName ? `${t(columnName)}:` : null}
      >
        {label ? <I18n label={label} html /> : children}
      </div>
    );
  }
}

export default TableCell;
